// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  getBaseStarPeakValue,
  getRockStarPeakValue,
  getSuperStarPeakValue,
  getMegaStarPeakValue,
  isPlacePerkEnabled,
  getIsLoyaltyTieringEnabled,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import RewardsPointsSlider from '../views/slider';
import RewardsPointsTable from '../views/table';
import RewardPointsStatusBarView from '../views/tile/RewardPointsStatusBar.view';
import {
  getPointsToNextRewardState,
  getCurrentPointsState,
  getTotalRewardsState,
  getMyPlaceNumber,
  isPlccUser,
  getTotalSpend,
  getCurrentPerkLevel,
  getNextPerkLevel,
  getSpendLeftForNextPerk,
  getCurrentTier,
} from '../../../../User/container/User.selectors';
import MPRLoyaltyPointsCard from '../../../molecule/MPRLoyaltyPointsCard';
import { setClickAnalyticsData, trackClick } from '../../../../../../../analytics/actions';
import { perkPercentage } from '../../../../PlacePerks/utils/PerkUtils';

/**
 * @function RewardsPointsContainer The RewardsPointsContainer component is the main container for the Rewards Points Container section
 * This component includes the Rewards Points view, it passes the my rewards point section with the rewards points details to be rendered
 * NOTE: this rewards point organism.
 * @param {router} router Router object to get the query key
 */

export class RewardsPointsContainer extends React.PureComponent {
  /**
   * @function render  Used to render the JSX of the component
   * @param    {[Void]} function does not accept anything.
   * @return   {[Object]} JSX of the component
   */
  render() {
    const {
      pointsToNextReward,
      currentPoints,
      totalRewards,
      tableView,
      plccUser,
      cardView,
      accountNumber,
      navigation,
      trackAnalyticsClick,
      isAccountDrawer,
      placePerkEnabled,
      totalSpend,
      currentPerkLevel,
      nextPerkLevel,
      spendLeftForNextPerk,
      baseStarPeakValue,
      rockStarPeakValue,
      superStarPeakValue,
      megaStarPeakValue,
      isLoyaltyTieringEnabled,
      currentTier,
    } = this.props;
    const percentage = perkPercentage(totalSpend, spendLeftForNextPerk + totalSpend);
    if (cardView) {
      return (
        <MPRLoyaltyPointsCard
          pointsToNextReward={pointsToNextReward}
          currentPoints={currentPoints}
          totalRewards={totalRewards}
          accountNumber={accountNumber}
          plccUser={plccUser}
          navigation={navigation}
          trackAnalyticsClick={trackAnalyticsClick}
          placePerkEnabled={placePerkEnabled}
          totalSpend={totalSpend}
          currentPerkLevel={currentPerkLevel}
          nextPerkLevel={nextPerkLevel}
          spendLeftForNextPerk={spendLeftForNextPerk}
          percentage={percentage}
          baseStarPeakValue={baseStarPeakValue}
          rockStarPeakValue={rockStarPeakValue}
          superStarPeakValue={superStarPeakValue}
          megaStarPeakValue={megaStarPeakValue}
        />
      );
    }
    if (tableView) {
      return isAccountDrawer ? (
        <RewardPointsStatusBarView
          pointsToNextReward={pointsToNextReward}
          currentPoints={currentPoints}
          totalRewards={totalRewards}
          plccUser={plccUser}
          isLoyaltyTieringEnabled={isLoyaltyTieringEnabled}
          currentTier={currentTier}
        />
      ) : (
        <RewardsPointsTable
          pointsToNextReward={pointsToNextReward}
          currentPoints={currentPoints}
          totalRewards={totalRewards}
          plccUser={plccUser}
        />
      );
    }
    return (
      <RewardsPointsSlider
        pointsToNextReward={pointsToNextReward}
        currentPoints={currentPoints}
        totalRewards={totalRewards}
        plccUser={plccUser}
      />
    );
  }
}

export const mapDispatchToProps = (dispatch) => {
  return {
    trackAnalyticsClick: (eventData, payload) => {
      dispatch(setClickAnalyticsData(eventData));

      const timer = setTimeout(() => {
        dispatch(trackClick(payload));
        clearTimeout(timer);
      }, 200);
    },
  };
};

const mapStateToProps = (state) => {
    return {
    pointsToNextReward: getPointsToNextRewardState(state),
    currentPoints: getCurrentPointsState(state),
    totalRewards: getTotalRewardsState(state),
    accountNumber: getMyPlaceNumber(state),
    plccUser: isPlccUser(state),
    placePerkEnabled: isPlacePerkEnabled(state),
    totalSpend: getTotalSpend(state),
    currentPerkLevel: getCurrentPerkLevel(state),
    nextPerkLevel: getNextPerkLevel(state),
    spendLeftForNextPerk: getSpendLeftForNextPerk(state),
    baseStarPeakValue: getBaseStarPeakValue(state),
    rockStarPeakValue: getRockStarPeakValue(state),
    superStarPeakValue: getSuperStarPeakValue(state),
    megaStarPeakValue: getMegaStarPeakValue(state),
    isLoyaltyTieringEnabled: getIsLoyaltyTieringEnabled(state),
    currentTier: getCurrentTier(state),
  };
};

RewardsPointsContainer.propTypes = {
  pointsToNextReward: PropTypes.number,
  currentPoints: PropTypes.number,
  totalRewards: PropTypes.number,
  plccUser: PropTypes.bool,
  tableView: PropTypes.bool,
  cardView: PropTypes.bool,
  accountNumber: PropTypes.string,
  navigation: PropTypes.shape({
    navigate: PropTypes.func,
    state: PropTypes.shape({
      params: PropTypes.shape({
        component: PropTypes.string,
      }),
    }),
  }).isRequired,
  totalSpend: PropTypes.number,
  currentPerkLevel: PropTypes.string,
  nextPerkLevel: PropTypes.string,
  spendLeftForNextPerk: PropTypes.number,
};

RewardsPointsContainer.defaultProps = {
  pointsToNextReward: '',
  currentPoints: '',
  totalRewards: '',
  plccUser: false,
  tableView: false,
  cardView: false,
  accountNumber: '',
  totalSpend: 0,
  currentPerkLevel: 'DEFAULT',
  nextPerkLevel: 'ROCKSTAR',
  spendLeftForNextPerk: 0,
};

export default connect(mapStateToProps, mapDispatchToProps)(RewardsPointsContainer);
